import React from 'react';
import { Button, Form, Modal } from "react-bootstrap";
import PayemnetsEditModal from "./PayemnetsEditModal";

const PayemnetsViewodal = ({ show, handleClose, isEdit }) => {

    return (
        <>
            <Modal show={show} onHide={handleClose} size={'lg'}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5 text-center">Payment Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Render row details */}
                    <div className="row">
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Driver Name:</span>
                            <p>
                                {isEdit?.driver?.full_name || '-'}
                            </p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Payment Method:</span>
                            <p>{isEdit?.method || '-'}</p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Payment Amount ($):</span>
                            <p>{isEdit?.amount || '-'}</p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Payment Date:</span>
                            <p>{isEdit?.date || '-'}</p>
                        </div>
                        <div className="col-md-12 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Payment Detail:</span>
                            <p>
                                {isEdit?.description || '-'}
                            </p>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {/*<PayemnetsEditModal*/}
            {/*    show={isEdit}*/}
            {/*    handleClose={() => setIsEdit(false)}*/}
            {/*/>*/}
        </>
    );
};

export default PayemnetsViewodal;